var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100 d-flex flex-column"},[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{staticClass:"flex-fill text-left pms-body-context",attrs:{"name":"context"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }